import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormGroupDirective, NgForm} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import {Router} from '@angular/router';
import {Member} from 'src/app/models/member';
import {CaexService} from 'src/app/services/caex.service';
import {MemberService} from 'src/app/services/member.service';
import {AlertComponent} from 'src/app/shared/dialogs/alert/alert.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-caex-new-member',
  templateUrl: './caex-new-member.component.html',
  styleUrls: ['./caex-new-member.component.scss']
})
export class CaexNewMemberComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();

  public memberForm: FormGroup;
  public subCategories: any[] = []
  public subCategorySelected: any = {};
  public spinner: boolean = false;

  constructor (
    public _caexService:  CaexService,
    private _memberService: MemberService,
    private snackBar: SnackBarIconService,
    private router: Router,
    private dialog: MatDialog,

  ) {

    this.loadSubCategories()
    this.memberForm = this._caexService.createMemberForm()
  }

  ngOnInit () {

  }


  registerMember () {
    if (this.memberForm.valid) {
      this.spinner = true

      let data = this.memberForm.getRawValue()

      let newMember: Member = new Member()
      newMember.name = data.name.trim();
      newMember.email = data.email.trim();
       
      newMember.cellPhonePrefix = data.cellPhonePrefix.trim();

      newMember.cellPhone = data.cellPhone
        .replace("(", "")
        .replace(")", "")
        .replace("-", "")
        .replace(" ", "")
        .trim()

      newMember.cpf = data.cpf
        .replace(".", "")
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .trim()
        
      newMember.crm = data.crm.trim()

      newMember.subCategory = this.subCategorySelected

      newMember.situation = '2'
      newMember.balance = 0

     // console.log(JSON.stringify(newMember))
     this._memberService.selectByDocNumber(newMember.cpf)
     .subscribe((docResult) => {

      if (!docResult.empty) {
        this.spinner = false;

        this.dialog.open(AlertComponent, {
          width: '450px',
          height: '270px',
          panelClass: 'custom-dialog-container',
          data: {title: "Alerta", message: "O documento: <br><br>" + newMember.cpf + "<br><br>" + "já está registrado."} 
        });

      } else {

      this._memberService.insert(newMember)
        .then((result) => {
          newMember.id = result.id
          this._caexService.currentMember = newMember
          this.snackBar.openSnackBar('Sucesso!', '', 'success');
          this.router.navigate([ 'caex-orders' ]);
        })
        .catch(() => {
          this.snackBar.openSnackBar('Erro!', '', 'error');
        })
        .finally(() => {
          this.spinner = false;
        })
      }
    })
    
    }

  }

  subCategorySelectedChange (id) {

    this.subCategorySelected = this.subCategories.find((e) => {
      return e.id == id
    })

   // console.log(JSON.stringify(this.subCategorySelected))
  }

  loadSubCategories () {
    //this._subcategoryService.selectSubcategories(true)
    this._caexService.selectSubcategoriesCaex()
      .subscribe((result) => {
        result.forEach((item) => {

          this.subCategories.push({
            'id': item.payload.doc.id,
            'name': item.payload.doc.data().name,
            'documents': item.payload.doc.data().documents,
            'documents_en': item.payload.doc.data().documents_en,
            'hidden': item.payload.doc.data().hidden,
            'partner': item.payload.doc.data().partner
          })

        })

      })
  }

  goBack(){
    this.router.navigate([ 'caex' ]);
  }
}

